import {selectDomain} from '.';
import {DocumentFields} from '../types';
import {createSelector} from 'reselect';

export default (k: keyof DocumentFields) =>
  createSelector([selectDomain], domain => {
    return domain.fields[k];
  });
